import './DotsMenu.scss'
import {DotsIcon, Dropdown, IconButton} from 'common/components'

interface DotsMenuProps {
  className?: string
  light?: boolean
  items: Item[]
  disabled?: boolean
}

interface Item {
  label: string
  onClick: () => void
}

export default function DotsMenu({light, items, ...props}: DotsMenuProps) {
  return (
    <Dropdown
      menu={{
        items: items.map((item) => ({
          ...item,
          key: item.label,
        })),
      }}
      placement="bottomRight"
      {...props}
    >
      <IconButton
        className={light ? 'DotsMenu-Button_light' : undefined}
        icon={<DotsIcon />}
        aria-label="Open menu"
      />
    </Dropdown>
  )
}
